import Dexie from 'dexie';

import { evaluateStatsmodelsTags } from './evaluateStatsmodelsTags';

const db = new Dexie('ReactSampleDB');
for(let tag of evaluateStatsmodelsTags) {
    db.version(1).stores({ ['processingStatsmodels_' + tag]: '++id' });
}
export default db;
